// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__0+DuG","redBack":"logo_redBack__19E-h"};